import React from "react";

const FormActions = () => {
  return (
    <div className="form-actions">
      <button type="button" className="btn btn-secondary">Cancel</button>
      <button type="submit" className="btn btn-primary">Save Changes</button>
    </div>
  );
};

export default FormActions;
